<template>
    <div>
        <DataTable :value="logs" selectionMode="single" dataKey="id" class="p-datatable-sm"
                   :paginator="pagination" :rows="50"
                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                   :rowsPerPageOptions="[20,50,500]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
            <Column header="Дата" >
                <template #body="slotProps">
                    {{short_timezoned(slotProps.data.date)}}
                </template>
            </Column>
            <Column header="" field="level" ></Column>
            <Column header="Сообщение" >
                <template #body="slotProps">
                    <span>{{slotProps.data.message}}</span>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import helperMethods from '@/helpers';

export default {
    components:{
        DataTable,
        Column
    },
    props:{
        logs: Array,
        pagination: {type: Boolean, default: false}
    },
    methods:{
        ...helperMethods
    }

}
</script>
